import React from 'react';
import {Form, FormGroup, ControlLabel, FormControl, Button, Modal} from 'react-bootstrap';
import PropTypes from 'prop-types';

class MailerTagFormModal extends React.Component{

    static contextTypes = { api:PropTypes.object, notifier: PropTypes.object };

    constructor( props ){
        super(props);
        if( !props.editing ) {
            this.state = {
                form: {
                    name:''
                }
            };
        }
        else {
            this.state = {
                form: {
                    name: props.editing.name
                }
            };
        }
    }

    onFormChange = ({target})=>{this.setState( { form: { ...this.state.form, [target.name]:target.value}} );};

    getFormValue = ( name ) => { return this.state.form[name]? this.state.form[name]:"";};

    saveForm = ()=>{
        if( !this.state.form.name) return this.context.notifier.error('Se requiere el nombre del Tag');
        const tag = this.state.form.name ;
        const finish = ()=>{
            if( this.props.didSave ) this.props.didSave();
            else if( this.props.onHide ) this.props.onHide();
        };

        if (this.props.editing) this.context.api.mailerTags.edit(this.props.editing.id, {name: tag}, undefined ).then(finish);
        else this.context.api.mailerTags.create( tag, undefined).then(finish);
    };

    render(){
        const { onHide } = this.props;
        return (
            <Modal show={true}
                   onHide={ onHide }>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.editing? 'Editar grupo de correo' : 'Añadir grupo de correo'}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form className='MailerTagFormModal'>
                        <FormGroup>
                            <ControlLabel>Nombre:</ControlLabel>
                            <FormControl
                                onKeyPress={event =>{if (event.key === "Enter") event.preventDefault();}}
                                autoFocus={true}
                                placeholder='Nombre del tag'
                                name='name'
                                value={ this.getFormValue('name') }
                                onChange={this.onFormChange}
                                required/>
                        </FormGroup>
                        <br/>
                        <Button
                            bsStyle='danger'
                            onClick={this.props.onHide}
                        >Cancelar</Button>
                        <Button
                            bsStyle='success'
                            className='pull-right'
                            onClick={this.saveForm}
                        >Guardar</Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }
}

export default MailerTagFormModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/components/MailerTagFormModal/index.jsx